import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/auth";
import axios from "axios";
import { backendlink } from "../../config";

export default function PartnerCustomerInfoList({ fetchTrigger }) {
  const { user } = useAuth();

  const navigate = useNavigate();

  const location = useLocation();

  const [organization, setOrganization] = useState({
    id: "",
    companyname: "",
    companyaddress: "",
    contactperson: "",
    email: "",
    phone: "",
    loginEmail: "",
  });

  useEffect(() => {
    if (location.state?.customerToken == null) {
      navigate("/");
    } else {
      const fetchData = async () => {
        try {
          const response = await axios.post(
            backendlink + "partner/getcustomer",
            {
              usertoken: user.userToken,
              customertoken: location.state.customerToken,
            },
            {
              headers: {
                token: user.token,
              },
            }
          );

          if (response.data.errorno === 0) {
            const outputArray = response.data.result.map((item) => {
              setOrganization({
                id: item.id,
                companyname: item.companyname,
                companyaddress: item.companyaddress,
                contactperson: item.contactperson,
                email: item.email,
                phone: item.phone,
                loginEmail: item.username,
              });
            });
          } else {
            alert(response.data.errmessage);
          }
        } catch (error) {
          alert(error);
        }
      };

      fetchData();
    }
  }, [user, fetchTrigger]);

  return (
    <div className="card-container">
      <div className="card">
        <h2>Organization Information</h2>
        <div className="user-info">
          <div className="user-info-item">
            <span className="label">Account ID (Auto Generated):</span>
            <span className="value">{organization.id}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Organization Name:</span>
            <span className="value">{organization.companyname}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Address:</span>
            <span className="value">{organization.companyaddress}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Login Email:</span>
            <span className="value">{organization.loginEmail}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Person:</span>
            <span className="value">{organization.contactperson}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Number:</span>
            <span className="value">{organization.phone}</span>
          </div>
          <div className="user-info-item">
            <span className="label">Contact Email:</span>
            <span className="value">{organization.email}</span>
          </div>
          {/* Add more fields as needed */}
        </div>
      </div>
    </div>
  );
}